export enum LIFESIZE_DOMAINS  {
  PRODUCTION = 'lifesizecloud.com',
  STAGING = 'lifesizebeta.com',
  DEVELOPMENT = 'lifesizebeta.com'
}

export enum LIFESIZE_SUBDOMAINS  {
  LOGIN = 'login',
  LEGACY = 'webapp'
}
